import { makeStyles } from '@material-ui/core/styles';
import { LayoutDirection } from 'features/app/ts/LayoutDirection';

interface CheckboxFieldProps extends LayoutDirection {
  isFirstPartOfSignUpShowed: boolean;
}

export const useStyles = makeStyles(theme => ({
  signUpFormWrapper: {
    padding: ({ isFirstPartOfSignUpShowed }: CheckboxFieldProps) =>
      isFirstPartOfSignUpShowed ? theme.spacing(20.5, 62.5, 20.5, 48.5) : theme.spacing(30, 37.5, 81, 34),
    maxWidth: ({ isFirstPartOfSignUpShowed }: CheckboxFieldProps) =>
      isFirstPartOfSignUpShowed ? theme.spacing(222) : theme.spacing(250.5),
    boxSizing: 'content-box',

    '& h1': {
      marginBottom: theme.spacing(16),
      textAlign: ({ direction }: LayoutDirection) => (direction === 'rtl' ? 'right' : 'unset'),
    },

    [theme.breakpoints.down('md')]: {
      padding: ({ isFirstPartOfSignUpShowed }: CheckboxFieldProps) =>
        isFirstPartOfSignUpShowed ? theme.spacing(25, 40) : theme.spacing(25, 40),
    },
    [theme.breakpoints.down('sm')]: {
      maxWidth: 'max-content !important',
      padding: ({ isFirstPartOfSignUpShowed }: CheckboxFieldProps) =>
        isFirstPartOfSignUpShowed ? theme.spacing(25) : theme.spacing(25),
      boxSizing: 'border-box',
    },
    [theme.breakpoints.down('xs')]: {
      padding: ({ isFirstPartOfSignUpShowed }: CheckboxFieldProps) =>
        isFirstPartOfSignUpShowed ? theme.spacing(25, 16) : theme.spacing(25, 17, 17),
      maxWidth: 'unset',
    },
  },
  successfulSignUpText: {
    color: theme.palette.grey['500'],
    fontSize: theme.spacing(9),
    lineHeight: '24px',
    marginBottom: theme.spacing(25),
  },
  backToHomepage: {
    marginTop: theme.spacing(50),
  },
}));
